import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=171e9b15&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e9b15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171e9b15')) {
      api.createRecord('171e9b15', component.options)
    } else {
      api.reload('171e9b15', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=171e9b15&scoped=true&", function () {
      api.rerender('171e9b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/comp/Accordion.vue"
export default component.exports